document.addEventListener('DOMContentLoaded', () => {
	if (document.querySelector('.mobileNav__list .menu-item-has-children')) {
		let subMenus = document.querySelectorAll(
			'.mobileNav__list .menu-item-has-children'
		);
		subMenus.forEach((subMenu) => {
			let link = subMenu.querySelector('a');
			let span = subMenu.querySelector('span');
			let ul = subMenu.querySelector('ul');
			link.addEventListener('click', (e) => {
				if (subMenu.querySelector('span')) {
					e.preventDefault();
					ul.classList.toggle('sub-menu--open');
					span.classList.toggle('open');
				}
			});
		});
	}
	const header = document.querySelector('.header');
	const hamburger = document.querySelector('.header .hamburger');
	const mobileNav = document.querySelector('.mobileNav');
	hamburger.addEventListener('click', () => {
		hamburger.classList.toggle('hamburger--opened');
		header.classList.toggle('header--open');
		hamburger.setAttribute(
			'aria-expanded',
			hamburger.classList.contains('hamburger--opened')
		);
		mobileNav.classList.toggle('open');
	});
	// window.addEventListener('scroll', () => {
	// 	document.body.scrollTop > 70 || document.documentElement.scrollTop > 70
	// 		? header.classList.add('header--scrolled')
	// 		: header.classList.remove('header--scrolled');
	// });
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);

	// window.addEventListener('resize', () => {
	// 	vh = window.innerHeight * 0.01;
	// 	document.documentElement.style.setProperty('--vh', `${vh}px`);
	// });
	if (document.querySelector('.hero ')) {
		const heroSwiper = new Swiper('.hero .swiper', {
			loop: 1,
			slidesPerView: 1,
			speed: 1400,
			effect: 'fade',
			autoplay: {
				delay: 5000,
			},
			pagination: {
				el: '.hero .swiper-pagination',
				clickable: 1,
			},
		});
	}
	if (document.querySelector('.switcher')) {
		const switcherSwiper = new Swiper('.switcher__slider .swiper', {
			slidesPerView: 1,
			simulateTouch: false,
			effect: 'fade',
			speed: 500,
		});
		const seoButtons = document.querySelectorAll(
			'.switcher__navigation .switcher__button'
		);
		seoButtons.forEach((switcherButton) => {
			switcherButton.addEventListener('click', () => {
				seoButtons.forEach((s) => {
					s.classList.remove('switcher__button--active');
				});
				switcherButton.classList.add('switcher__button--active');
				switcherSwiper.slideTo(switcherButton.getAttribute('data-index'), 500);
			});
		});
	}

	if (document.querySelector('.opinions')) {
		const opinions = new Swiper('.opinions .swiper', {
			slidesPerView: 1,
			effect: 'fade',
			speed: 1000,
			pagination: {
				el: '.opinions .swiper .swiper-pagination',
				clickable: 1,
			},
		});
	}
	if (document.querySelector('.clients')) {
		const clients = new Swiper('.clients .swiper', {
			speed: 500,
			slidesPerView: 1,
			breakpoints: {
				400: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				550: {
					slidesPerView: 3,
					spaceBetween: 20,
				},
				800: {
					slidesPerView: 4,
					spaceBetween: 30,
				},
				1200: {
					slidesPerView: 5,
					spaceBetween: 30,
				},
			},
			pagination: {
				el: '.clients .swiper .swiper-pagination',
				clickable: 1,
			},
			autoplay: {
				delay: 1000,
			},
		});
	}

	if (document.querySelector('.opinionsBlock')) {
		const opinionsBlock = new Swiper('.opinionsBlock .swiper', {
			slidesPerView: 1,
			effect: 'fade',
			speed: 1000,
			pagination: {
				el: '.opinionsBlock .swiper .swiper-pagination',
				clickable: 1,
			},
		});
	}
	if (document.querySelector('.seo')) {
		const seoslider = new Swiper('.seo .swiper', {
			slidesPerView: 1,
			simulateTouch: false,
			effect: 'fade',
			speed: 500,
		});
		const seoButtons = document.querySelectorAll('.seo__buttons .seo__button');
		seoButtons.forEach((seoButton) => {
			seoButton.addEventListener('click', () => {
				seoButtons.forEach((s) => {
					s.classList.remove('seo__button--active');
				});
				seoButton.classList.add('seo__button--active');
				seoslider.slideTo(seoButton.getAttribute('data-id'), 500);
			});
		});
	}
	if (document.querySelector('.faq')) {
		const faqslider = new Swiper('.faq .swiper', {
			slidesPerView: 1,
			simulateTouch: false,
			effect: 'fade',
			speed: 500,
		});
		const faqButtons = document.querySelectorAll('.faq__buttons .faq__button');
		const details = document.querySelectorAll('.faq__slider details');
		faqButtons.forEach((faqButton) => {
			faqButton.addEventListener('click', () => {
				details.forEach((detail) => {
					detail.removeAttribute('open');
				});
				faqButtons.forEach((s) => {
					s.classList.remove('faq__button--active');
				});
				faqButton.classList.add('faq__button--active');
				faqslider.slideTo(faqButton.getAttribute('data-id'), 500);
			});
		});
	}
	if (document.querySelector('.parameters .customSelect')) {
		const select = document.querySelector('.parameters .customSelect select');
		select.addEventListener('change', () => {
			if (select.value != 'null') {
				window.location = select.value;
			}
		});
	}
	if (document.querySelector('.customUpload')) {
		const input = document.querySelector('.customUpload input');
		const button = document.querySelector('.customUpload button');
		button.addEventListener('click', (e) => {
			e.preventDefault();
			input.click();
		});
	}
	if (document.querySelectorAll('input[type="date"].disabled')) {
		const disabledDateInputs = document.querySelectorAll(
			'input[type="date"].disabled'
		);
		disabledDateInputs.forEach((disabledInput) => {
			disabledInput.addEventListener('focus', (e) => {
				disabledInput.classList.remove('disabled');
			});
		});
	}
	// if(document.querySelector('.careerBanner')){
	// 	const careerCopyButton = document.querySelector('.careerBanner .button')
	// 	const careerRodo = document.querySelector('.careerBanner .careerBanner__rodo')
	// 	careerCopyButton.addEventListener('click',()=>{
	// 		navigator.clipboard.writeText(careerRodo.getAttribute('data-rodo')).then(function() {
	// 			console.log('Async: Copying to clipboard was successful!');
	// 		  }, function(err) {
	// 			console.error('Async: Could not copy text: ', err);
	// 		  });
	// 	})
	// }
	if (document.querySelector('.iconsBlock')) {
		const iconsBlocks = document.querySelectorAll('.iconsBlock');
		iconsBlocks.forEach((iconBlock) => {
			var button = iconBlock.querySelector('.button');
			var person = iconBlock.querySelector('.personCard');
			button.addEventListener('click', () => {
				if (button.getAttribute('data-open') == 1) {
					person.style.display = 'none';
					button.setAttribute('data-open', 0);
				} else {
					person.style.display = 'grid';
					button.setAttribute('data-open', 1);
				}
			});
		});
	}
	if (document.querySelector('.offerArchive__card')) {
		const offerArchives = document.querySelectorAll('.offerArchive__card');
		offerArchives.forEach((offerArchive) => {
			var button = offerArchive.querySelector('.button--secondary');
			var person = offerArchive.querySelector('.personCard');
			button.addEventListener('click', () => {
				if (button.getAttribute('data-open') == 1) {
					person.style.display = 'none';
					button.setAttribute('data-open', 0);
				} else {
					person.style.display = 'grid';
					button.setAttribute('data-open', 1);
				}
			});
		});
	}
	if (document.querySelector('.careerBanner__copy')) {
		const copy = document.querySelector('.careerBanner__copy');

		copy.addEventListener('click', () => {
			navigator.clipboard.writeText(copy.getAttribute('data-rodo'));
		});
	}

    $(document).ready(function(){
		try{
			if($(location.hash)){
				$('html,body').animate({scrollTop:$(location.hash).offset().top}, 500);
			}
		}catch(e){
			
		}
	  });
});
